/* FBT cart recommendations — La Boutique du Bracelet
 *
 * This bundle deliberately owns the cart-only FBT experience. Product-section
 * bundles are not initialised here: cart drawer markup is replaced by Impact at
 * runtime, so the controller is built from the local JSON payload every time.
 */
(function () {
  "use strict";

  /* A cart drawer can contain the asset tag after every section response. Do not
   * install a second observer/listener set when the browser executes it twice. */
  if (window.__LBDBFBTCartRuntime) {
    window.__LBDBFBTCartRuntime.start();
    return;
  }

  var ROOT_SELECTOR = "[data-fbt-root][data-fbt-cart]";
  var FOCUSABLE_SELECTOR = [
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])"
  ].join(",");

  function strictCents(value) {
    if (typeof value === "number" && Number.isSafeInteger(value) && value >= 0) return value;
    if (typeof value === "string" && /^\d+$/.test(value)) {
      var parsed = Number(value);
      return Number.isSafeInteger(parsed) ? parsed : null;
    }
    return null;
  }

  function variantWithinCap(variant, cap) {
    return Boolean(variant && variant.available === true && variantAtOrUnderCap(variant, cap));
  }

  function variantAtOrUnderCap(variant, cap) {
    var price = variant && strictCents(variant.price);
    return Boolean(variant && price !== null && (cap === null || price <= cap));
  }

  function firstAvailableVariant(product, cap) {
    var variants = (product && product.variants) || [];
    return variants.find(function (variant) { return variantWithinCap(variant, cap); }) || null;
  }

  /* An explicit recommendation variant wins, even if it was just sold out
   * between rendering and the click: the CTA must then be unavailable instead
   * of silently adding another colour. If no id is supplied/found, use the
   * first available variant, then retain an unavailable one only to display it. */
  function findVariant(product, variantId, cap) {
    var variants = (product && product.variants) || [];
    var requested = variantId === undefined || variantId === null || variantId === "" ? null : String(variantId);
    if (requested !== null) {
      var exact = variants.find(function (variant) {
        return variant && String(variant.id) === requested;
      });
      if (exact) return exact;
    }
    return firstAvailableVariant(product, cap) || variants[0] || null;
  }

  /* Transfer only an exact size, never a guessed length or another colour.
   * Unit signatures are language-independent; named generic sizes stay generic. */
  function sizeDescriptor(name, value) {
    var label = String(name || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    var text = String(value || "").normalize("NFKC").toLowerCase().replace(/,/g, ".");
    var hasCm = /\bcm\b/.test(text.replace(/(\d)(cm|mm)/g, "$1 $2")) || /\bcm\b/.test(label);
    var hasMm = /\bmm\b/.test(text.replace(/(\d)(cm|mm)/g, "$1 $2")) || /\bmm\b/.test(label);
    var numbers = text.match(/\d+(?:\.\d+)?/g) || [];
    if (hasCm !== hasMm && numbers.length) {
      return { kind: hasCm ? "length-cm" : "connector-mm", key: (text.indexOf("+") >= 0 ? "extension:" : "size:") + numbers.map(Number).join("|") };
    }
    var sizeName = /(?:taille|longueur|length|size|gro(?:ss|ß)e|lange|lunghezza|taglia|misura|maat|lengte|talla|tamano|comprimento|tamanho|rozmiar|dlugosc|velikost|delka|velkost|dlzka|storrelse|langd|størrelse|lengde|marime|lungime|μεγεθος|μηκος|размер|довжина|розмір|uzunluk|beden|pikkus|suurus|izmers|garums|dydis|ilgis|méret|hossz|サイズ|長さ|尺寸|长度|長度|크기|길이|مقاس|طول)/i;
    if (sizeName.test(label) && text.trim()) return { kind: "generic-size", key: text.replace(/\s+/g, "").trim() };
    return null;
  }

  function withCartSize(product, original, preference, cap) {
    if (!original || original.available !== true || !preference || !Array.isArray(preference.options) || !Array.isArray(preference.values)) return original;
    var sourceSizes = preference.options.map(function (name, index) {
      return sizeDescriptor(name, preference.values[index]);
    }).filter(Boolean);
    if (!sourceSizes.length) return original;
    var wanted = (original.options || []).slice();
    var changed = false;
    (product.options || []).forEach(function (name, index) {
      var current = sizeDescriptor(name, wanted[index]);
      if (!current) return;
      var compatible = sourceSizes.filter(function (size) { return size.kind === current.kind; });
      if (compatible.length !== 1) return;
      var match = (product.variants || []).map(function (variant) {
        return variant.options && variant.options[index];
      }).find(function (value) {
        var descriptor = sizeDescriptor(name, value);
        return descriptor && descriptor.kind === compatible[0].kind && descriptor.key === compatible[0].key;
      });
      if (match !== undefined && wanted[index] !== match) { wanted[index] = match; changed = true; }
    });
    if (!changed) return original;
    return (product.variants || []).find(function (variant) {
      return variantWithinCap(variant, cap) && Array.isArray(variant.options) && variant.options.length === wanted.length && variant.options.every(function (value, index) { return value === wanted[index]; });
    }) || original;
  }

  function priceCents(value) {
    var price = Number(value);
    return Number.isFinite(price) ? Math.round(price) : 0;
  }

  function uniqueStrings(values, limit) {
    var output = [];
    (values || []).forEach(function (value) {
      if (value === undefined || value === null || value === "") return;
      value = String(value);
      if (output.indexOf(value) === -1 && output.length < limit) output.push(value);
    });
    return output;
  }

  function photoSrc(image) {
    return typeof image === "string" ? image : image && (image.src || image.url) || "";
  }

  function photoKey(image) {
    /* Legacy URLs may differ only by protocol or Shopify's width query. */
    return photoSrc(image).replace(/^https?:/i, "").split("?")[0];
  }

  function variantPhoto(variant, product) {
    if (!variant) return "";
    if (Object.prototype.hasOwnProperty.call(variant, "variant_image")) return photoSrc(variant.variant_image);
    var src = photoSrc(variant.featured_image);
    /* Old Liquid substituted product.featured_image for unassigned variants.
     * Without an explicit image id, that default is not proof of association. */
    return src && (variant.image_id || (variant.featured_image && variant.featured_image.id) || photoKey(src) !== photoKey(product.featured_image)) ? src : "";
  }

  function productPhotoSources(product) {
    if (Array.isArray(product.mediaImages)) {
      return product.mediaImages.filter(function (image) { return image && photoSrc(image.src); }).map(function (image) {
        return { src: photoSrc(image.src), id: image.id, variantIds: uniqueStrings(image.variantIds, Infinity) };
      });
    }
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var sources = Array.isArray(product.images) ? product.images.map(photoSrc).filter(Boolean) : [];
    /* Keep the legacy source order too; never promote the selected variant.
     * Only an absent gallery needs a featured-image fallback. */
    if (!sources.length) sources = uniqueStrings([photoSrc(product.featured_image)].concat(variants.map(function (variant) { return variantPhoto(variant, product); })), Infinity);
    return sources.map(function (src) {
      return {
        src: src,
        id: null,
        variantIds: uniqueStrings(variants.filter(function (variant) {
          return variant && variantPhoto(variant, product) && photoKey(variantPhoto(variant, product)) === photoKey(src);
        }).map(function (variant) { return variant.id; }), Infinity)
      };
    });
  }

  function getCartSectionId() {
    var drawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer") || document.querySelector("cart-notification-drawer");
    var section = drawer && drawer.closest(".shopify-section");
    return section && section.id ? section.id.replace("shopify-section-", "") : null;
  }

  function getShopifyRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function isVisible(element) {
    return !!(element && !element.hidden && element.getClientRects().length && !element.closest("[aria-hidden='true']"));
  }

  function dispatchCartEvents(cart, addedItems) {
    var cartType = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType) || "drawer";
    if (cartType === "page") {
      window.location.assign(getShopifyRoot() + "cart");
      return;
    }

    /* Impact's CartDrawer reads cart.sections synchronously (theme.js.liquid
     * lines 1995–2005). A null/missing sections response must use refresh,
     * rather than handing either native controller an undefined section. */
    if (cart && cart.sections && Object.keys(cart.sections).length) {
      document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: { items: addedItems || [], cart: cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cart }
      }));
    } else {
      /* CartNotificationDrawer also reads sections.variant-added immediately.
       * Refresh first (and only) when Shopify did not return section HTML. */
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }
  }

  class CartFbtSection {
    constructor(root, runtime) {
      this.root = root;
      this.runtime = runtime;
      this.abortController = new AbortController();
      this.signal = this.abortController.signal;
      this.sectionId = root.dataset.sectionId || "";
      this.uid = "fbt-cart-" + (this.sectionId || Math.random().toString(36).slice(2));
      this.modelState = [];
      this.isAdding = false;
      this.lastTrigger = null;
      this.scrollState = null;
      this.pausedDrawerTrap = null;
      this.portaled = new Set();

      this.readPayload();
      this.labels = this.readLabels();
      this.currency = (root.dataset.currency || "EUR").toUpperCase();
      this.offer = this.readOffer();
      this.moneyFormatter = this.createMoneyFormatter();

      this.modal = root.querySelector("[data-fbt-modal]");
      this.modalTitle = root.querySelector("[data-fbt-modal-title]");
      this.modalIntro = root.querySelector("[data-fbt-modal-intro]");
      this.modalBody = root.querySelector("[data-fbt-modal-body]");
      this.modalTotal = root.querySelector("[data-fbt-modal-total]");
      this.modalCompare = root.querySelector("[data-fbt-modal-compare]");
      this.modalAdd = root.querySelector("[data-fbt-modal-add]");
      this.modalAddLabel = this.modalAdd && this.modalAdd.querySelector(".fbt-modal__add-label");

      this.syncCardPrices();
      this.bind();
      this.initCarousel();
      this.initModalScrollHint();
      if (this.sectionId) window.__FBTSections[this.sectionId] = this;
    }

    /* The payload is inert JSON inside the root. Never rely on a script being
     * executed after Impact replaces drawer HTML. The legacy FBTData object is
     * fallback-only for backwards API compatibility. */
    readPayload() {
      var localPayload = null;
      var script = this.root.querySelector('template[data-fbt-payload], script[type="application/json"][data-fbt-payload]');
      if (script) {
        try {
          localPayload = JSON.parse((script.content ? script.content.textContent : script.textContent) || "{}");
        } catch (error) {
          console.warn("[FBT cart] Invalid local payload", error);
        }
      }

      if (localPayload && typeof localPayload === "object") {
        this.data = { products: localPayload.products || {} };
        this.config = localPayload.config || {};
      } else {
        var legacy = window.FBTData && window.FBTData[this.sectionId];
        this.data = legacy && typeof legacy === "object" ? legacy : { products: {} };
        this.config = (this.data && this.data.config) || window.FBTConfig || {};
      }
      if (!this.data.products || typeof this.data.products !== "object") this.data.products = {};
    }

    /* The cap is emitted both on the root and in the inert payload. Any absent,
     * malformed, or contradictory value fails closed rather than becoming 0 or
     * an uncapped offer. */
    readOffer() {
      var config = this.config || {};
      var rootCap = strictCents(this.root.dataset.fbtPriceCap);
      var payloadCap = strictCents(config.anchorUnitPriceCap);
      var rootKey = String(this.root.dataset.fbtAnchorKey || "");
      var payloadKey = config.anchorKey === undefined || config.anchorKey === null ? "" : String(config.anchorKey);
      var rootProductId = String(this.root.dataset.fbtAnchorProductId || "");
      var payloadProductId = config.anchorProductId === undefined || config.anchorProductId === null ? "" : String(config.anchorProductId);
      var rootCurrency = String(this.root.dataset.fbtAnchorCurrency || this.root.dataset.currency || "").toUpperCase();
      var payloadCurrency = String(config.currency || "").toUpperCase();
      var valid = rootCap !== null && payloadCap !== null && rootCap === payloadCap && rootKey !== "" && rootKey === payloadKey && rootProductId !== "" && rootProductId === payloadProductId && rootCurrency !== "" && rootCurrency === payloadCurrency && rootCurrency === this.currency;
      return { valid: valid, cap: valid ? rootCap : null, anchorKey: rootKey, anchorProductId: rootProductId, currency: rootCurrency };
    }

    canUseVariant(variant) {
      return Boolean(this.offer && this.offer.valid && variantWithinCap(variant, this.offer.cap));
    }

    readLabels() {
      var ds = this.root.dataset;
      return {
        color: ds.fbtLblColor || "Couleur",
        size: ds.fbtLblSize || "Taille",
        engraving: ds.fbtLblEngraving || "Gravure",
        engravingField: ds.fbtLblEngravingField || "Texte à graver",
        typography: ds.fbtLblTypography || "Typographie",
        chars: ds.fbtLblChars || "Caractères",
        add: ds.fbtLblAdd || "Ajouter au panier",
        soldOut: ds.fbtLblSoldOut || "Indisponible",
        modalTitle: ds.fbtLblModalTitle || "Choisissez votre modèle",
        modalTitleSingle: ds.fbtLblModalTitleSingle || ds.fbtLblModalTitle || "Choisissez votre modèle",
        modalIntroSingle: ds.fbtLblModalIntroSingle || "",
        modelWord: ds.fbtLblModel || "Modèle",
        engravingSymbol: ds.fbtLblEngravingSymbol || "Emoji",
        previous: ds.fbtLblPrevious || "Précédent",
        next: ds.fbtLblNext || "Suivant"
      };
    }

    createMoneyFormatter() {
      var locale = document.documentElement.lang || navigator.language || "fr-FR";
      try {
        return new Intl.NumberFormat(locale, { style: "currency", currency: this.currency });
      } catch (_error) {
        return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    money(cents) {
      var formatted = this.moneyFormatter.format(priceCents(cents) / 100);
      /* In the unlikely event a shop currency is not accepted by Intl, retain
       * a meaningful ISO suffix instead of falling back to a hard-coded euro. */
      return formatted;
    }

    syncCardPrices() {
      var self = this;
      this.root.querySelectorAll("[data-fbt-reco-card]").forEach(function (card) {
        var product = self.data.products[card.dataset.productId];
        var variant = withCartSize(product, findVariant(product, card.dataset.variantId, self.offer.cap), self.config.sizePreference, self.offer.cap);
        var wrapper = card.querySelector("[data-fbt-card-price]");
        if (!self.offer.valid || !variantAtOrUnderCap(variant, self.offer.cap)) {
          card.hidden = true;
          card.disabled = true;
          card.setAttribute("aria-hidden", "true");
          return;
        }
        card.hidden = false;
        card.disabled = false;
        card.removeAttribute("aria-hidden");
        if (!wrapper) return;
        var price = priceCents(variant.price);
        card.dataset.variantId = String(variant.id);
        var discounted = price > 0;
        var finalPrice = discounted ? Math.ceil(price / 2) : price;
        wrapper.dataset.fbtPriceCents = String(price);
        wrapper.dataset.fbtFinalCents = String(finalPrice);
        wrapper.dataset.fbtDiscount = String(discounted);
        wrapper.textContent = "";
        var final = document.createElement("span");
        final.className = "fbt-recos__final";
        final.textContent = self.money(finalPrice);
        wrapper.appendChild(final);
        if (discounted) {
          var original = document.createElement("del");
          original.className = "fbt-recos__original";
          original.textContent = self.money(price);
          wrapper.appendChild(original);
        }
      });
    }
    initCarousel() {
      this.carouselTrack = this.root.querySelector("[data-fbt-carousel-track]");
      this.carouselPrev = this.root.querySelector("[data-fbt-carousel-prev]");
      this.carouselNext = this.root.querySelector("[data-fbt-carousel-next]");
      if (!this.carouselTrack || !this.carouselPrev || !this.carouselNext) return;

      var self = this;
      this.carouselDesktop = window.matchMedia ? window.matchMedia("(min-width: 1000px)") : null;
      var update = function () { self.updateCarousel(); };
      this.carouselTrack.addEventListener("scroll", update, { passive: true, signal: this.signal });
      window.addEventListener("resize", update, { passive: true, signal: this.signal });
      document.addEventListener("dialog:after-show", update, { signal: this.signal });
      this.root.addEventListener("load", update, { capture: true, signal: this.signal });
      if (this.carouselDesktop && this.carouselDesktop.addEventListener) {
        this.carouselDesktop.addEventListener("change", update, { signal: this.signal });
      }
      this.carouselPrev.addEventListener("click", function (event) {
        event.preventDefault();
        self.scrollCarousel(-1);
      }, { signal: this.signal });
      this.carouselNext.addEventListener("click", function (event) {
        event.preventDefault();
        self.scrollCarousel(1);
      }, { signal: this.signal });
      if (window.ResizeObserver) {
        this.carouselObserver = new ResizeObserver(update);
        this.carouselObserver.observe(this.carouselTrack);
        this.carouselTrack.querySelectorAll("[data-fbt-reco-card]").forEach(function (card) {
          self.carouselObserver.observe(card);
        });
      }
      this.updateCarousel();
    }

    carouselPosition() {
      var track = this.carouselTrack;
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      // Use physical left/right even in RTL markets (modern browsers use negative scrollLeft).
      var rtl = window.getComputedStyle(track).direction === "rtl";
      var position = rtl ? max + track.scrollLeft : track.scrollLeft;
      return { max: max, position: Math.max(0, Math.min(max, position)), rtl: rtl };
    }

    updateCarousel() {
      if (!this.carouselTrack || !this.carouselPrev || !this.carouselNext) return;
      var state = this.carouselPosition();
      var desktop = this.carouselDesktop ? this.carouselDesktop.matches : window.innerWidth >= 1000;
      var overflow = desktop && this.carouselTrack.clientWidth > 0 && state.max > 2;
      this.carouselPrev.hidden = !overflow || state.position <= 2;
      this.carouselNext.hidden = !overflow || state.position >= state.max - 2;
      var carousel = this.carouselTrack.closest(".fbt-recos__carousel");
      if (carousel) {
        carousel.dataset.fbtCarouselOverflow = String(overflow);
        carousel.dataset.fbtCanScrollLeft = String(!this.carouselPrev.hidden);
        carousel.dataset.fbtCanScrollRight = String(!this.carouselNext.hidden);
      }
      // Do not leave keyboard focus on a button that has just disappeared at an edge.
      var active = document.activeElement;
      if ((active === this.carouselPrev || active === this.carouselNext) && active.hidden) {
        var remaining = !this.carouselPrev.hidden ? this.carouselPrev : !this.carouselNext.hidden ? this.carouselNext : this.carouselTrack.querySelector("[data-fbt-reco-card]:not([hidden])");
        if (remaining) remaining.focus({ preventScroll: true });
      }
    }

    scrollCarousel(direction) {
      if (!this.carouselTrack || !this.carouselDesktop || !this.carouselDesktop.matches) return;
      var state = this.carouselPosition();
      var card = this.carouselTrack.querySelector("[data-fbt-reco-card]:not([hidden])");
      var gap = parseFloat(window.getComputedStyle(this.carouselTrack).columnGap) || 0;
      var step = card ? card.getBoundingClientRect().width + gap : this.carouselTrack.clientWidth;
      var target = Math.max(0, Math.min(state.max, state.position + direction * step));
      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.carouselTrack.scrollTo({ left: state.rtl ? target - state.max : target, behavior: reduced ? "auto" : "smooth" });
    }

    bind() {
      var self = this;

      /* Recommendation cards are native buttons. Click delegation deliberately
       * leaves keyboard handling to the browser, preserving Space/Enter native
       * behaviour and avoiding double invocations. */
      this.root.addEventListener("click", function (event) {
        var card = event.target.closest && event.target.closest("[data-fbt-reco-card]");
        if (!card || !self.root.contains(card)) return;
        event.preventDefault();
        self.openSingle(card.dataset.productId, card.dataset.variantId, card);
      }, { signal: this.signal });

      if (this.modal) {
        this.modal.addEventListener("click", function (event) {
          if (event.target.closest("[data-fbt-modal-close]")) self.closeModal();
        }, { signal: this.signal });
      }
      if (this.modalAdd) {
        this.modalAdd.addEventListener("click", function () { self.addToCart(); }, { signal: this.signal });
      }

      /* Capture prevents the open cart drawer's Escape/focus trap from taking
       * ownership while the FBT dialog is portaled above it. */
      document.addEventListener("keydown", function (event) {
        if (!self.modal || self.modal.hidden) return;
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopImmediatePropagation();
          self.closeModal();
          return;
        }
        if (event.key === "Tab") self.trapFocus(event);
      }, { capture: true, signal: this.signal });
    }

    getProduct(productId) {
      return this.data && this.data.products ? this.data.products[String(productId)] : null;
    }

    openSingle(productId, variantId, trigger) {
      if (!this.modal) return false;

      /* Re-read inert root data for every opening. This has local payload
       * precedence and prevents a stale global FBTData object surviving a
      * cart-drawer section replacement. */
      this.readPayload();
      this.offer = this.readOffer();
      var product = this.getProduct(productId);
      if (!product || !this.offer.valid) return false;

      this.lastTrigger = trigger || this.lastTrigger;
      this.modelState.forEach(function (model) { if (model.photoObserver) model.photoObserver.disconnect(); });
      this.modelState = [];
      this.modal.classList.remove("fbt-modal--gold");
      this.modal.classList.add("fbt-modal--green");
      if (this.modalTitle) this.modalTitle.textContent = this.labels.modelWord + " " + (product.short || product.title || "");
      if (this.modalIntro) this.modalIntro.textContent = this.labels.modalIntroSingle;
      if (this.modalBody) this.modalBody.replaceChildren();

      var requestedVariant = findVariant(product, variantId, this.offer.cap);
      var initialVariant = variantAtOrUnderCap(requestedVariant, this.offer.cap) ? withCartSize(product, requestedVariant, this.config.sizePreference, this.offer.cap) : null;
      var optionSeed = initialVariant || (product.variants || [])[0];
      var state = {
        productId: String(productId),
        pdata: product,
        variant: initialVariant,
        selectedOptions: optionSeed && Array.isArray(optionSeed.options) ? optionSeed.options.slice() : [],
        props: {}, row: null
      };
      this.modelState.push(state);
      if (this.modalBody) this.modalBody.appendChild(this.buildModelRow(state, 0));
      this.refreshModal();
      this.showModal();
      return true;
    }

    buildPhotoCarousel(state) {
      var self = this;
      var product = state.pdata;
      var media = document.createElement("div");
      media.className = "fbt-mrow__media";
      var badge = document.createElement("span");
      badge.className = "fbt-photo__offer-badge";
      badge.textContent = "-50%";
      badge.hidden = true;
      state.photoOfferBadge = badge;
      media.appendChild(badge);
      var track = document.createElement("div");
      track.className = "fbt-photo__track";
      track.id = this.uid + "-photos-" + state.productId;
      track.tabIndex = 0;
      track.setAttribute("role", "group");
      track.setAttribute("aria-label", product.short || product.title || this.labels.modelWord);
      media.appendChild(track);
      state.photoTrack = track;
      state.photos = [];
      state.photoIndex = 0;
      state.photoSources = productPhotoSources(product);

      function addPhoto(src) {
        if (!src) return;
        state.photos.push(src);
        var slide = document.createElement("div");
        slide.className = "fbt-photo__slide";
        var image = document.createElement("img");
        image.className = "fbt-mrow__img";
        image.alt = product.title || "";
        image.src = src;
        image.width = 600;
        image.height = 600;
        image.loading = state.photos.length === 1 ? "eager" : "lazy";
        image.decoding = "async";
        image.draggable = false;
        slide.appendChild(image);
        track.appendChild(slide);
      }

      function arrow(previous) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "fbt-photo__nav fbt-photo__nav--" + (previous ? "prev" : "next");
        button.setAttribute(previous ? "data-fbt-photo-prev" : "data-fbt-photo-next", "");
        button.setAttribute("aria-label", previous ? self.labels.previous : self.labels.next);
        button.setAttribute("aria-controls", track.id);
        var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "18");
        svg.setAttribute("height", "18");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("fill", "none");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
        var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", previous ? "m14.5 5-7 7 7 7" : "m9.5 5 7 7-7 7");
        path.setAttribute("stroke", "currentColor");
        path.setAttribute("stroke-width", "1.8");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        svg.appendChild(path);
        button.appendChild(svg);
        return button;
      }
      var prev = arrow(true);
      var next = arrow(false);
      var counter = document.createElement("span");
      counter.className = "fbt-photo__count";
      counter.setAttribute("aria-live", "polite");
      counter.setAttribute("aria-atomic", "true");
      media.append(prev, next, counter);

      function render() {
        var total = state.photos.length;
        media.hidden = total === 0;
        prev.hidden = total < 2 || state.photoIndex === 0;
        next.hidden = total < 2 || state.photoIndex >= total - 1;
        counter.hidden = total < 2;
        counter.textContent = total ? (state.photoIndex + 1) + " / " + total : "";
        Array.from(track.children).forEach(function (slide, index) {
          var active = index === state.photoIndex;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
          if (active) slide.querySelector("img").loading = "eager";
        });
        if ((document.activeElement === prev && prev.hidden) || (document.activeElement === next && next.hidden)) track.focus({ preventScroll: true });
      }
      function isRtl() { return window.getComputedStyle(track).direction === "rtl"; }
      function goTo(index, smooth) {
        if (!state.photos.length) return;
        state.photoIndex = Math.max(0, Math.min(state.photos.length - 1, index));
        var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var left = state.photoIndex * track.clientWidth * (isRtl() ? -1 : 1);
        if (typeof track.scrollTo === "function") track.scrollTo({ left: left, behavior: smooth && !reduced ? "smooth" : "auto" });
        else track.scrollLeft = left;
        render();
      }
      state.updatePhotos = function (focusVariant) {
        var variant = state.variant;
        var selectedId = variant && variant.id !== undefined && variant.id !== null ? String(variant.id) : null;
        var visible = state.photoSources.filter(function (image) {
          return !image.variantIds.length || (selectedId !== null && image.variantIds.indexOf(selectedId) !== -1);
        });
        /* Rebuild without retaining other variant slides. The selected packshot
         * is first; all remaining photos retain their relative Shopify order. */
        state.visiblePhotoSources = visible;
        state.photos = [];
        state.photoIndex = 0;
        track.replaceChildren();
        visible.forEach(function (image) { addPhoto(image.src); });
        var target = -1;
        if (focusVariant && selectedId !== null) {
          var imageId = variant.image_id || (variant.featured_image && variant.featured_image.id);
          var imageSrc = variantPhoto(variant, product) || photoSrc(variant.featured_image) || photoSrc(product.featured_image);
          if (imageId) target = visible.findIndex(function (image) { return image.id !== undefined && image.id !== null && String(image.id) === String(imageId); });
          if (target === -1 && imageSrc) target = visible.findIndex(function (image) { return photoKey(image.src) === photoKey(imageSrc); });
          if (target === -1) target = visible.findIndex(function (image) { return image.variantIds.indexOf(selectedId) !== -1; });
          /* An explicit selected/default image can be absent from a legacy
           * gallery, but an image assigned only to another variant stays out. */
          if (target === -1 && imageSrc && !state.photoSources.some(function (image) { return photoKey(image.src) === photoKey(imageSrc); })) {
            visible.push({ src: imageSrc, id: imageId || null, variantIds: [selectedId] });
            addPhoto(imageSrc);
            target = visible.length - 1;
          }
          if (target > 0) {
            visible.unshift(visible.splice(target, 1)[0]);
            state.photos.unshift(state.photos.splice(target, 1)[0]);
            track.prepend(track.children[target]);
          }
          if (target !== -1) target = 0;
        }
        if (state.photos.length) goTo(target === -1 ? 0 : target, false);
        else {
          if (typeof track.scrollTo === "function") track.scrollTo({ left: 0, behavior: "auto" });
          else track.scrollLeft = 0;
          render();
        }
      };
      state.alignPhotos = function () { if (track.clientWidth > 0) goTo(state.photoIndex, false); };
      track.addEventListener("scroll", function () {
        if (!track.clientWidth || !state.photos.length) return;
        var position = Math.max(0, (isRtl() ? -1 : 1) * track.scrollLeft);
        state.photoIndex = Math.min(state.photos.length - 1, Math.round(position / track.clientWidth));
        render();
      }, { passive: true, signal: this.signal });
      track.addEventListener("keydown", function (event) {
        var index = state.photoIndex;
        if (event.key === "ArrowRight") index += isRtl() ? -1 : 1;
        else if (event.key === "ArrowLeft") index += isRtl() ? 1 : -1;
        else if (event.key === "Home") index = 0;
        else if (event.key === "End") index = state.photos.length - 1;
        else return;
        event.preventDefault();
        goTo(index, true);
      }, { signal: this.signal });
      prev.addEventListener("click", function () { goTo(state.photoIndex - 1, true); }, { signal: this.signal });
      next.addEventListener("click", function () { goTo(state.photoIndex + 1, true); }, { signal: this.signal });
      if (window.ResizeObserver) state.photoObserver = new ResizeObserver(state.alignPhotos);
      else if (!this.photoResizeBound) {
        this.photoResizeBound = true;
        window.addEventListener("resize", function () {
          self.modelState.forEach(function (model) { if (model.alignPhotos) model.alignPhotos(); });
        }, { passive: true, signal: this.signal });
      }
      state.updatePhotos(true);
      return media;
    }

    buildModelRow(state, index) {
      var self = this;
      var product = state.pdata;
      var row = document.createElement("div");
      row.className = "fbt-mrow";
      state.row = row;

      var head = document.createElement("div");
      head.className = "fbt-mrow__head";
      var media = this.buildPhotoCarousel(state);
      head.appendChild(media);
      row.appendChild(head);

      var meta = document.createElement("div");
      meta.className = "fbt-mrow__meta";
      var prices = document.createElement("div");
      prices.className = "fbt-mrow__price";
      prices.setAttribute("data-fbt-modal-prices", "");
      prices.setAttribute("aria-live", "polite");
      prices.setAttribute("aria-atomic", "true");
      if (product.title) {
        var description = document.createElement("p");
        description.className = "fbt-mrow__description";
        description.textContent = product.title;
        meta.appendChild(description);
      }
      meta.appendChild(prices);
      head.appendChild(meta);

      var options = Array.isArray(product.options) ? product.options : [];
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var visibleOptions = options.map(function (optionName, optionIndex) {
        return {
          name: optionName,
          index: optionIndex,
          values: uniqueStrings(variants.map(function (variant) { return variant.options && variant.options[optionIndex]; }), Infinity)
        };
      }).filter(function (option) { return option.values.length > 1; });
      if (visibleOptions.length) {
        var grid = document.createElement("div");
        grid.className = "fbt-fields-grid";
        grid.setAttribute("data-fbt-option-count", String(visibleOptions.length));
        visibleOptions.forEach(function (productOption) {
          var optionIndex = productOption.index;
          var field = document.createElement("div");
          field.className = "fbt-field";
          var label = document.createElement("label");
          label.className = "fbt-field__label";
          label.textContent = productOption.name;
          var select = document.createElement("select");
          var safeHandle = String(product.handle || product.id || "product").replace(/[^a-z0-9_-]/gi, "-");
          select.id = self.uid + "-" + safeHandle + "-option-" + optionIndex;
          select.setAttribute("data-fbt-opt", String(optionIndex));
          label.htmlFor = select.id;
          productOption.values.forEach(function (value) {
            var option = document.createElement("option");
            option.value = value;
            option.textContent = value;
            if (state.selectedOptions[optionIndex] === value) option.selected = true;
            select.appendChild(option);
          });
          select.addEventListener("change", function () { self.onOptionChange(state); }, { signal: self.signal });
          field.append(label, select);
          grid.appendChild(field);
        });
        row.appendChild(grid);
      }

      if (product.engraving && product.engraving.enabled === true) row.appendChild(this.buildEngraving(state));
      this.syncOptionAvailability(state);
      this.applyVariant(state, true);
      return row;
    }

    applyVariant(state, focusVariant) {
      if (!state || !state.row) return;
      var variant = state.variant;
      if (state.updatePhotos) state.updatePhotos(focusVariant === true);
      if (state.photoOfferBadge) state.photoOfferBadge.hidden = !(this.offer.valid && variantAtOrUnderCap(variant, this.offer.cap) && priceCents(variant.price) > 0);
    }

    onOptionChange(state) {
      if (!state || !state.row) return;
      var selected = (state.selectedOptions || []).slice();
      state.row.querySelectorAll("[data-fbt-opt]").forEach(function (select) {
        selected[Number(select.dataset.fbtOpt)] = select.value;
      });
      state.selectedOptions = selected;
      var variants = state.pdata.variants || [];
      /* Do not retain the previously selected id for an absent combination. */
      state.variant = variants.find(function (variant) {
        return variant && Array.isArray(variant.options) && variant.options.length === selected.length && variant.options.every(function (value, index) {
          return value === selected[index];
        });
      }) || null;
      if (state.variant && !variantAtOrUnderCap(state.variant, this.offer.cap)) state.variant = null;
      this.syncOptionAvailability(state);
      this.applyVariant(state, true);
      this.refreshModal();
    }

    /* Native select options remain visible for unavailable variants, but each
     * context is disabled when it cannot form an in-stock under-cap variant.
     * The selected full combination is always retained; there is no automatic
     * colour/length substitution after the shopper changes an option. */
    syncOptionAvailability(state) {
      if (!state || !state.row) return;
      var self = this;
      var selects = Array.from(state.row.querySelectorAll("[data-fbt-opt]"));
      var selected = state.selectedOptions || [];
      var variants = Array.isArray(state.pdata.variants) ? state.pdata.variants : [];
      selects.forEach(function (select) {
        var optionIndex = Number(select.dataset.fbtOpt);
        Array.from(select.options).forEach(function (option) {
          option.disabled = !variants.some(function (variant) {
            return self.canUseVariant(variant) && Array.isArray(variant.options) && variant.options.length === selected.length && variant.options[optionIndex] === option.value && variant.options.every(function (value, index) {
              return index === optionIndex || value === selected[index];
            });
          });
        });
      });
    }

    buildEngraving(state) {
      var self = this;
      var engraving = state.pdata.engraving || {};
      var wrap = document.createElement("div");
      wrap.className = "fbt-engraving";
      var fields = Array.isArray(engraving.fields) && engraving.fields.length ? engraving.fields : [this.labels.engravingField];
      var maxChars = Math.max(0, parseInt(engraving.maxChars, 10) || 0);
      var enableFonts = this.config.enableFonts === true && Array.isArray(this.config.fonts) && this.config.fonts.filter(Boolean).length;
      var symbols = engraving.showSymbols === false || !this.config.symbols ? [] : String(this.config.symbols).split(/[,\n]+/).map(function (symbol) { return symbol.trim(); }).filter(Boolean);

      fields.forEach(function (fieldName) {
        var block = document.createElement("div");
        block.className = "fbt-engraving__field";

        if (enableFonts) {
          var fontLabel = document.createElement("label");
          fontLabel.className = "fbt-field__label";
          fontLabel.textContent = self.labels.typography + " — " + fieldName;
          var fontSelect = document.createElement("select");
          fontSelect.setAttribute("aria-label", fontLabel.textContent);
          fontSelect.setAttribute("data-fbt-engraving", "Typographie");
          fontSelect.setAttribute("data-fbt-engraving-field", fieldName);
          self.config.fonts.filter(Boolean).forEach(function (font) {
            var fontOption = document.createElement("option");
            fontOption.value = font;
            fontOption.textContent = font;
            fontOption.style.fontFamily = font;
            fontSelect.appendChild(fontOption);
          });
          fontSelect.addEventListener("change", function () { self.collectEngraving(state); }, { signal: self.signal });
          block.append(fontLabel, fontSelect);
        }

        var textLabel = document.createElement("label");
        textLabel.className = "fbt-field__label";
        textLabel.textContent = fieldName;
        var inputRow = document.createElement("div");
        inputRow.className = "fbt-eng-row" + (symbols.length ? " has-symbols" : "");
        var input = document.createElement("input");
        input.type = "text";
        input.className = "fbt-eng-input";
        input.placeholder = fieldName;
        input.setAttribute("aria-label", fieldName);
        input.setAttribute("data-fbt-engraving", "Texte");
        input.setAttribute("data-fbt-engraving-field", fieldName);
        /* No HTML maxlength: it counts UTF-16 code units. Input is constrained
         * below with Array.from so an emoji/grapheme surrogate pair counts once. */
        inputRow.appendChild(input);

        var menu = null;
        if (symbols.length) {
          var symbolButton = document.createElement("button");
          symbolButton.type = "button";
          symbolButton.className = "fbt-eng-symbtn";
          symbolButton.textContent = self.labels.engravingSymbol;
          symbolButton.setAttribute("aria-expanded", "false");
          inputRow.appendChild(symbolButton);
          menu = document.createElement("div");
          menu.className = "fbt-eng-symbols hidden";
          symbols.forEach(function (symbol) {
            var symbolChoice = document.createElement("button");
            symbolChoice.type = "button";
            symbolChoice.className = "fbt-eng-symbol";
            symbolChoice.textContent = symbol;
            symbolChoice.addEventListener("click", function () {
              var characters = Array.from(input.value + symbol);
              input.value = maxChars ? characters.slice(0, maxChars).join("") : characters.join("");
              input.dispatchEvent(new Event("input", { bubbles: true }));
              input.focus();
            }, { signal: self.signal });
            menu.appendChild(symbolChoice);
          });
          symbolButton.addEventListener("click", function () {
            var isOpen = menu.classList.toggle("hidden") === false;
            symbolButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
          }, { signal: self.signal });
        }

        var count = document.createElement("span");
        count.className = "fbt-engraving__count";
        var update = function () {
          var characters = Array.from(input.value);
          if (maxChars && characters.length > maxChars) {
            input.value = characters.slice(0, maxChars).join("");
            characters = Array.from(input.value);
          }
          if (maxChars) {
            count.textContent = self.labels.chars + " " + characters.length + "/" + maxChars;
            count.classList.toggle("is-limit", characters.length >= maxChars);
          }
          input.classList.toggle("is-filled", input.value.trim().length > 0);
          self.collectEngraving(state);
        };
        input.addEventListener("input", update, { signal: self.signal });
        block.append(textLabel, inputRow);
        if (menu) block.appendChild(menu);
        if (maxChars) {
          count.textContent = self.labels.chars + " 0/" + maxChars;
          block.appendChild(count);
        }
        wrap.appendChild(block);
      });
      return wrap;
    }

    collectEngraving(state) {
      if (!state || !state.row) return;
      var properties = {};
      state.row.querySelectorAll("[data-fbt-engraving]").forEach(function (element) {
        var type = element.getAttribute("data-fbt-engraving");
        var field = element.getAttribute("data-fbt-engraving-field") || "Gravure";
        var value = (element.value || "").trim();
        if (type === "Texte" && value) properties[field + " - Texte"] = value;
        if (type === "Typographie") properties["__fbt_typography_" + field] = value;
      });
      Object.keys(properties).forEach(function (key) {
        if (key.indexOf("__fbt_typography_") !== 0) return;
        var field = key.slice("__fbt_typography_".length);
        if (properties[field + " - Texte"] && properties[key]) properties[field + " - Typographie"] = properties[key];
        delete properties[key];
      });
      state.props = properties;
    }

    refreshModal() {
      var state = this.modelState[0];
      var variant = state && state.variant;
      var canAdd = Boolean(variant && variant.id && this.canUseVariant(variant));
      var prices = state && state.row && state.row.querySelector("[data-fbt-modal-prices]");
      if (prices) {
        prices.replaceChildren();
        prices.hidden = !canAdd;
        if (canAdd) {
          var price = priceCents(variant.price);
          var final = document.createElement("span");
          final.className = "fbt-mrow__final";
          final.textContent = this.money(price > 0 ? Math.ceil(price / 2) : price);
          prices.appendChild(final);
          if (price > 0) {
            var original = document.createElement("del");
            original.className = "fbt-mrow__original";
            original.textContent = this.money(price);
            prices.appendChild(original);
          }
        }
      }
      if (this.modalTotal) { this.modalTotal.textContent = ""; this.modalTotal.hidden = true; }
      /* Prices belong to the selected model, not to a second footer total. */
      if (this.modalCompare) {
        this.modalCompare.textContent = "";
        this.modalCompare.hidden = true;
        this.modalCompare.style.display = "none";
      }
      this.updateCta(canAdd);
    }

    updateCta(canAdd) {
      if (!this.modalAdd) return;
      var disabled = this.isAdding || !canAdd;
      this.modalAdd.disabled = disabled;
      this.modalAdd.setAttribute("aria-disabled", disabled ? "true" : "false");
      if (this.modalAddLabel) this.modalAddLabel.textContent = canAdd ? this.labels.add : this.labels.soldOut;
    }

    setLoading(loading) {
      this.isAdding = loading;
      if (this.modalAdd) {
        this.modalAdd.classList.toggle("is-loading", loading);
        this.modalAdd.setAttribute("aria-busy", loading ? "true" : "false");
      }
      var state = this.modelState[0];
      this.updateCta(Boolean(state && state.variant && state.variant.id && this.canUseVariant(state.variant)));
    }

    async rejectStaleOffer() {
      this.closeModal({ restoreFocus: false });
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      throw new Error("Offre FBT indisponible ou modifiée");
    }

    async confirmFreshOffer(state, root) {
      if (!this.offer || !this.offer.valid || !state || !state.variant || !state.variant.id) return false;
      var cartResponse = await fetch(root + "cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } });
      if (!cartResponse.ok) return false;
      var cart = await cartResponse.json();
      var cartCurrency = String((cart.currency && (cart.currency.iso_code || cart.currency)) || cart.currency || "").toUpperCase();
      if (cartCurrency !== this.offer.currency) return false;
      var line = (cart.items || []).find(function (item) { return item && String(item.key) === this.offer.anchorKey; }, this);
      if (!line || String((line.product_id === undefined ? line.product && line.product.id : line.product_id)) !== this.offer.anchorProductId) return false;
      var freshCap = strictCents(line.original_price);
      if (freshCap === null) return false;

      var handle = state.pdata && state.pdata.handle;
      if (!handle) return false;
      var productResponse = await fetch(root + "products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin", headers: { "Accept": "application/json" } });
      if (!productResponse.ok) return false;
      var freshProduct = await productResponse.json();
      if (!freshProduct || String(freshProduct.id) !== state.productId) return false;
      var freshVariant = (freshProduct.variants || []).find(function (variant) { return variant && String(variant.id) === String(state.variant.id); });
      var freshPrice = freshVariant && strictCents(freshVariant.price);
      return Boolean(freshVariant && freshVariant.available === true && freshPrice !== null && freshPrice <= freshCap);
    }

    async addToCart() {
      if (this.isAdding || !this.modelState.length) return;
      var state = this.modelState[0];
      if (!state.variant || !state.variant.id || !this.canUseVariant(state.variant)) {
        this.updateCta(false);
        return;
      }
      this.collectEngraving(state);
      var item = { id: state.variant.id, quantity: 1 };
      if (state.props && Object.keys(state.props).length) item.properties = state.props;

      this.setLoading(true);
      try {
        var root = getShopifyRoot();
        var stillValid = false;
        try {
          stillValid = await this.confirmFreshOffer(state, root);
        } catch (_error) {
          stillValid = false;
        }
        if (!stillValid) await this.rejectStaleOffer();

        var sections = uniqueStrings(["variant-added", getCartSectionId()], 5);
        var prepareEvent = new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sections }
        });
        document.documentElement.dispatchEvent(prepareEvent);
        /* The native drawer listener appends its own section id. Normalise after
         * dispatching to remove duplicates and keep Shopify's sections limit. */
        sections = uniqueStrings(prepareEvent.detail.sections, 5);

        var response = await fetch(root + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [item],
            sections: sections,
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) {
          var failed = await response.json().catch(function () { return {}; });
          throw new Error(failed.description || "Erreur d'ajout au panier");
        }
        var added = await response.json();
        var cartType = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType) || "drawer";
        if (cartType === "page" || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === "cart")) {
          window.location.assign(root + "cart");
          return;
        }

        var cartResponse = await fetch(root + "cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } });
        if (!cartResponse.ok) throw new Error("Impossible d'actualiser le panier");
        var cart = await cartResponse.json();
        /* Explicit null preserves the native refresh fallback when Shopify does
         * not return bundled sections (rather than passing undefined). */
        cart.sections = added && added.sections ? added.sections : null;
        var addedItems = added && added.items ? added.items : (added && added.id ? [added] : []);
        document.dispatchEvent(new CustomEvent("fbt:added"));
        this.closeModal();
        dispatchCartEvents(cart, addedItems);
      } catch (error) {
        console.error("[FBT cart]", error);
        window.alert(this.root.dataset.errorMsg || "Une erreur est survenue. Veuillez réessayer.");
      } finally {
        this.setLoading(false);
      }
    }

    portalToBody(element) {
      if (!element || this.portaled.has(element)) return;
      element.__fbtHome = element.parentNode;
      element.__fbtNext = element.nextSibling;
      document.body.appendChild(element);
      element.classList.add("fbt-overlay--portaled");
      this.portaled.add(element);
    }

    restoreFromBody(element) {
      if (!element || !this.portaled.has(element)) return;
      var home = element.__fbtHome;
      var next = element.__fbtNext;
      element.classList.remove("fbt-overlay--portaled");
      try {
        if (home) home.insertBefore(element, next && next.parentNode === home ? next : null);
        else element.remove();
      } catch (_error) {
        element.remove();
      }
      element.__fbtHome = null;
      element.__fbtNext = null;
      this.portaled.delete(element);
    }

    initModalScrollHint() {
      if (!this.modal || !this.modalBody) return;
      var update = this.updateModalScrollHint.bind(this);
      this.modalBody.addEventListener("scroll", update, { passive: true, signal: this.signal });
      this.modalBody.addEventListener("load", update, { capture: true, signal: this.signal });
      window.addEventListener("resize", update, { passive: true, signal: this.signal });
      if (window.visualViewport) window.visualViewport.addEventListener("resize", update, { passive: true, signal: this.signal });
      if (window.ResizeObserver) this.modalScrollObserver = new ResizeObserver(update);
    }

    updateModalScrollHint() {
      if (!this.modal || !this.modalBody) return;
      var body = this.modalBody;
      var remaining = body.scrollHeight - body.clientHeight - Math.max(0, body.scrollTop);
      var canScrollMore = !this.modal.hidden && body.clientHeight > 0 && remaining > 2;
      this.modal.classList.toggle("fbt-modal--scroll-more", canScrollMore);
    }

    pauseDrawerFocusTrap() {
      var drawer = this.root.closest("cart-drawer") || document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
      if (!drawer || this.pausedDrawerTrap) return;
      try {
        var trap = drawer.focusTrap;
        if (trap && typeof trap.pause === "function") {
          trap.pause();
          this.pausedDrawerTrap = trap;
        }
      } catch (_error) { /* drawer is optional on cart-page mode */ }
    }

    unpauseDrawerFocusTrap() {
      if (!this.pausedDrawerTrap) return;
      try {
        if (typeof this.pausedDrawerTrap.unpause === "function") this.pausedDrawerTrap.unpause();
      } catch (_error) { /* native drawer may already have been disconnected */ }
      this.pausedDrawerTrap = null;
    }

    showModal() {
      if (!this.modal) return;
      this.pauseDrawerFocusTrap();
      this.portalToBody(this.modal);
      if (!this.scrollState) {
        this.scrollState = { element: document.documentElement, overflow: document.documentElement.style.overflow };
        document.documentElement.style.overflow = "hidden";
      }
      this.modal.hidden = false;
      this.modal.setAttribute("aria-hidden", "false");
      if (this.modalBody) {
        this.modalBody.scrollTop = 0;
        if (this.modalScrollObserver) {
          this.modalScrollObserver.disconnect();
          this.modalScrollObserver.observe(this.modalBody);
          Array.from(this.modalBody.children).forEach((row) => this.modalScrollObserver.observe(row));
        }
      }
      var self = this;
      window.requestAnimationFrame(function () {
        if (!self.modal || self.modal.hidden) return;
        self.updateModalScrollHint();
        self.modelState.forEach(function (model) {
          if (model.photoObserver) model.photoObserver.observe(model.photoTrack);
          if (model.alignPhotos) model.alignPhotos();
        });
        var close = self.modal.querySelector("button[data-fbt-modal-close]");
        var dialog = self.modal.querySelector("[role='document']");
        var target = close || dialog;
        if (target) {
          if (!target.hasAttribute("tabindex") && target === dialog) target.tabIndex = -1;
          target.focus({ preventScroll: true });
        }
      });
    }

    closeModal(options) {
      options = options || {};
      if (!this.modal) return;
      var wasOpen = !this.modal.hidden;
      this.modal.hidden = true;
      this.modal.setAttribute("aria-hidden", "true");
      this.modal.classList.remove("fbt-modal--scroll-more");
      if (this.modalScrollObserver) this.modalScrollObserver.disconnect();
      this.modelState.forEach(function (model) { if (model.photoObserver) model.photoObserver.disconnect(); });
      this.restoreFromBody(this.modal);
      if (this.scrollState) {
        /* Restore exactly the drawer's prior inline value. In particular, if
         * Impact had already locked it to hidden, this does not unlock it. */
        this.scrollState.element.style.overflow = this.scrollState.overflow;
        this.scrollState = null;
      }
      this.unpauseDrawerFocusTrap();
      if (wasOpen && options.restoreFocus !== false && this.lastTrigger && this.lastTrigger.isConnected) {
        this.lastTrigger.focus({ preventScroll: true });
      }
    }

    trapFocus(event) {
      var dialog = this.modal.querySelector("[role='document']") || this.modal;
      var focusables = Array.from(dialog.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
      if (!focusables.length) {
        event.preventDefault();
        dialog.focus({ preventScroll: true });
        return;
      }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      } else if (!dialog.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    }

    dispose() {
      this.closeModal({ restoreFocus: false });
      this.portaled.forEach(this.restoreFromBody.bind(this));
      this.abortController.abort();
      if (this.carouselObserver) this.carouselObserver.disconnect();
      if (this.sectionId && window.__FBTSections[this.sectionId] === this) delete window.__FBTSections[this.sectionId];
      this.modelState = [];
    }
  }

  class CartFbtRuntime {
    constructor() {
      this.instances = new Map();
      this.started = false;
      this.observer = null;
      this.scanQueued = false;
      this.lifecycleAbort = new AbortController();
    }

    start() {
      if (this.started) {
        this.scan(document);
        return;
      }
      this.started = true;
      var self = this;
      var initialise = function () {
        self.scan(document);
        self.observe();
      };
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initialise, { once: true, signal: this.lifecycleAbort.signal });
      } else {
        initialise();
      }
      document.addEventListener("shopify:section:load", function () { self.queueScan(); }, { signal: this.lifecycleAbort.signal });
    }

    scan(scope) {
      var roots = [];
      if (scope && scope.nodeType === 1 && scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
      var owner = scope && scope.querySelectorAll ? scope : document;
      roots = roots.concat(Array.from(owner.querySelectorAll(ROOT_SELECTOR)));
      roots.forEach((root) => {
        if (!this.instances.has(root)) this.instances.set(root, new CartFbtSection(root, this));
      });
      this.instances.forEach((instance, root) => {
        if (!root.isConnected) {
          instance.dispose();
          this.instances.delete(root);
        }
      });
    }

    observe() {
      if (this.observer || !document.documentElement) return;
      var self = this;
      this.observer = new MutationObserver(function (records) {
        /* Rows and engraving controls only mutate descendants inside an existing
         * root; ignoring them prevents the observer from creating an init loop.
         * Added/removed roots are the only mutations requiring reconciliation. */
        var relevant = records.some(function (record) {
          return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
            return node.nodeType === 1 && (node.matches(ROOT_SELECTOR) || node.querySelector(ROOT_SELECTOR));
          });
        });
        if (relevant) self.queueScan();
      });
      this.observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    queueScan() {
      if (this.scanQueued) return;
      this.scanQueued = true;
      var self = this;
      queueMicrotask(function () {
        self.scanQueued = false;
        self.scan(document);
      });
    }

    getBySectionId(sectionId) {
      var registry = window.__FBTSections || {};
      return registry[sectionId] || null;
    }
  }

  window.__FBTSections = window.__FBTSections || {};
  var runtime = new CartFbtRuntime();
  window.__LBDBFBTCartRuntime = runtime;
  window.shopifyFBTInit = function () { runtime.start(); };
  window.FBTOpenSingle = function (sectionId, productId, variantId) {
    runtime.start();
    var instance = runtime.getBySectionId(String(sectionId));
    return instance ? instance.openSingle(productId, variantId) : false;
  };
  runtime.start();
})();
